var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8SouthKorea(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "48px",
    height: "48px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 20,
    fill: "#f5f5f5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M11.91,21.096l4.355-6.711l0.59,0.383L12.5,21.475L11.91,21.096z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M8.793,28.928l0.672-0.434l4.348,6.715l-0.668,0.434L8.793,28.928z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M32.664,13.74l0.668-0.434l4.426,6.781l-0.672,0.438L32.664,13.74z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M10.344,20.127l4.355-6.711l0.586,0.379l-4.355,6.711L10.344,20.127z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M33.445,18.4l0.586-0.383l2.016,3.105l-0.59,0.383L33.445,18.4z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M36.453,31.643l2.016-3.105l0.586,0.383l-2.016,3.102L36.453,31.643z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M12.637,31.51l0.586-0.379l2.016,3.102l-0.586,0.383L12.637,31.51z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M36.559,16.416l0.586-0.383l2.027,3.094l-0.586,0.383L36.559,16.416z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M33.371,29.619l2.016-3.105l0.586,0.383l-2.016,3.102L33.371,29.619z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M34.937,30.588l2.023-3.102l0.668,0.438l-2.02,3.102L34.937,30.588z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M31.148,14.768l0.586-0.383l2.027,3.094l-0.586,0.383L31.148,14.768z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M34.105,35.221l1.996-3.117l0.59,0.379l-2,3.113L34.105,35.221z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M10.352,27.865l0.672-0.434l2,3.113l-0.672,0.434L10.352,27.865z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M34.266,12.771l0.586-0.387l2.031,3.094l-0.586,0.383L34.266,12.771z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M31.008,33.17l2.02-3.098l0.672,0.438l-2.023,3.098L31.008,33.17z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M32.535,34.24l2.004-3.109l0.672,0.434l-2.004,3.109L32.535,34.24z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M8.758,19.139l4.43-6.781l0.672,0.438l-4.43,6.781L8.758,19.139z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M11.855,26.85l0.59-0.383l4.348,6.715l-0.586,0.383L11.855,26.85z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "#f44336",
    d: "M20.5,27.482c1.924,0,3.5-1.576,3.5-3.5s1.576-3.5,3.5-3.5s3.5,1.576,3.5,3.5c0-3.849-3.151-7-7-7 s-7,3.151-7,7C17,25.907,18.576,27.482,20.5,27.482z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "#3949ab",
    d: "M27.5,20.482c-1.924,0-3.5,1.576-3.5,3.5s-1.576,3.5-3.5,3.5s-3.5-1.576-3.5-3.5c0,3.849,3.151,7,7,7 s7-3.151,7-7C31,22.058,29.424,20.482,27.5,20.482z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8SouthKorea);
export default __webpack_public_path__ + "static/media/icons8-south-korea.4d218f1bb1e05a2fa7f7285d292625d6.svg";
export { ForwardRef as ReactComponent };